export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5167.5dbd8f58.jpg";